import { AxiosPromise } from "axios";
import { request } from "utils/request";

export const staffApi = {
  upload: (file: File): AxiosPromise<any> => {
    const formData = new FormData();
    formData.append("file", file);

    return request({
      url: "/v1/admin/staff/upload",
      method: "post",
      data: formData,
    });
  },
};
